import { defineComponent } from 'vue';
import templateMount, { type MountTemplate, type RecordListener } from './template-mount';
import DialogWrap from './dialog-template/dialog-wrap.vue';

type OpenDialogOptions = {
  props?: Record<string, any>;
  style?: Record<string, string>;
  parentEl?: HTMLElement | string;
  on?: RecordListener;
  rootProps?: Record<string, any>; // 如store, router
}
export function createDialog(contentTemplate: MountTemplate, options?: OpenDialogOptions) {
  const wrap: any = DialogWrap;
  return defineComponent({
    render() {
      const closeFn = (...e: Array<unknown>) => {
        this.$emit('close', ...e);
      };

      // 构建事件处理器对象
      const contentEvents: Record<string, any> = {
        onCancel: (...e: Array<unknown>) => {
          this.$emit('cancel', ...e);
        },
        onConfirm: (...e: Array<unknown>) => {
          this.$emit('confirm', ...e);
        },
        onClose: closeFn,
      };

      // 合并自定义事件监听器
      if (options?.on) {
        Object.entries(options.on).forEach(([key, handler]) => {
          const eventKey = `on${key.charAt(0).toUpperCase()}${key.slice(1)}`;
          contentEvents[eventKey] = handler;
        });
      }

      return (
        <wrap
          onClose={closeFn}
          {...options?.rootProps}
        >
          <contentTemplate
            {...contentEvents}
            {...options?.props}
            style={options?.style}
          ></contentTemplate>
        </wrap>
      );
    },
  });
}
export interface ExtendedPromise<T> extends Promise<T> {
  close: () => void;
}
export function openDialog(template: MountTemplate, options?: OpenDialogOptions){
  const dialog = createDialog(template, options) as any;
  const amountConfirmFn = templateMount(dialog, { parentEl: options?.parentEl });
  let instance: any;

  const promise = new Promise((resolve, reject) => {
    instance = amountConfirmFn({
      on: {
        cancel(...arg: any[]) {
          instance?.destroy?.();
          reject(arg.length > 0 ? (arg.length === 1 ? arg[0] : arg) : 'cancel');
        },
        confirm(...arg: any[]) {
          instance?.destroy?.();
          const result = arg.length > 0 ? (arg.length === 1 ? arg[0] : arg) : true;
          resolve(result);
        },
        close(...arg: any[]) {
          instance?.destroy?.();
          reject(arg.length > 0 ? (arg.length === 1 ? arg[0] : arg) : 'close');
        },
      },
    });
  });

  const dialogPromise = Object.assign(promise, {
    close: (): void => {
      instance?.destroy?.();
    }
  }) as ExtendedPromise<any>;

  const activeElement = document.activeElement as HTMLElement;
  activeElement?.blur?.();
  return dialogPromise;
}
